// @flow
import {
  GET_ALL_BILLING_COMPANY,
  ADMIN_GET_CURRENT_BILLING,
  ADMIN_GET_HISTORY_BILLING,
  ADMIN_GET_HISTORY_BILLING_DETAIL,
  GET_ALL_BILLING_PARTS,
  ADMIN_GET_COMPANY_PRICES,
  ADMIN_UPDATE_COMPANY_PRICE,
  ADMIN_UPLOAD_INVOICE_FILE
} from "../../global/actions/actionNames";

const initialState = {
  companies: null,
  parts: null
};

const billingReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case GET_ALL_BILLING_COMPANY:
      if (actions.companies !== undefined) {
        return {
          ...state,
          companies: actions.companies
        };
      }
      return state;

    case ADMIN_GET_CURRENT_BILLING:
      if (actions.companyId !== undefined && actions.current !== undefined) {
        let companies = [...state.companies];
        let index = companies.findIndex(x => x.id === actions.companyId);
        if (index > -1) {
          let company = { ...companies[index] };
          company.current = { ...actions.current };

          companies[index] = company;
          return {
            ...state,
            companies: companies
          };
        }
      }
      return state;

    case ADMIN_GET_HISTORY_BILLING:
      if (actions.companyId !== undefined && actions.history !== undefined) {
        let companies = [...state.companies];
        let index = companies.findIndex(x => x.id === actions.companyId);
        if (index > -1) {
          let company = { ...companies[index] };
          company.history = [...actions.history];

          companies[index] = company;
          return {
            ...state,
            companies: companies
          };
        }
      }
      return state;

    case ADMIN_GET_COMPANY_PRICES:
      if (actions.companyId !== undefined && actions.products !== undefined) {
        let companies = [...state.companies];
        let index = companies.findIndex(x => x.id === actions.companyId);
        if (index > -1) {
          let company = { ...companies[index] };
          company.products = [...actions.products];

          companies[index] = company;
          return {
            ...state,
            companies: companies
          };
        }
      }
      return state;

    case ADMIN_GET_HISTORY_BILLING_DETAIL:
      if (
        actions.companyId !== undefined &&
        actions.billindId !== undefined &&
        actions.logs !== undefined
      ) {
        let companies = [...state.companies];
        let index = companies.findIndex(x => x.id === actions.companyId);
        if (index > -1) {
          let company = { ...companies[index] };
          let history = [...company.history];
          let index2 = history.findIndex(x => x.id === actions.billindId);
          if (index2 > -1) {
            let billing = { ...history[index2] };
            billing.logs = [...actions.logs];

            history[index2] = billing;
            company.history = [...history];
            companies[index] = company;

            return {
              ...state,
              companies: companies
            };
          }
        }
      }
      return state;

    case ADMIN_UPDATE_COMPANY_PRICE:
      if (
        actions.companyId !== undefined &&
        actions.product !== undefined &&
        actions.product.id !== undefined
      ) {
        let companies = [...state.companies];
        let index = companies.findIndex(x => x.id === actions.companyId);
        if (index > -1) {
          let company = { ...companies[index] };
          let products = [...company.products];
          let index2 = products.findIndex(x => x.id === actions.product.id);
          if (index2 > -1) {
            products[index2] = {...actions.product};
          }
          else {
            products.unshift({...actions.product});
          }

          company.products = [...products];
          companies[index] = company;
          return {
            ...state,
            companies: companies
          };
        }
      }
      return state;

    case GET_ALL_BILLING_PARTS:
      if (actions.parts !== undefined) {
        return {
          ...state,
          parts: actions.parts
        };
      }
      return state;

    case ADMIN_UPLOAD_INVOICE_FILE:
      if (
        actions.companyId !== undefined &&
        actions.billingId !== undefined &&
        actions.invoice !== undefined &&
        actions.paidOn !== undefined
      ) {
        let companies = [...state.companies];
        let index = companies.findIndex(x => x.id === actions.companyId);
        if (index > -1) {
          let company = { ...companies[index] };
          let history = [...company.history];
          let index2 = history.findIndex(x => x.id === actions.billingId);
          if (index2 > -1) {
            let billing = { ...history[index2] };

            billing.paidOn = actions.paidOn;
            billing.invoice = actions.invoice;

            history[index2] = billing;
            company.history = [...history];
            companies[index] = company;

            return {
              ...state,
              companies: companies
            };
          }
        }
      }
      return state;

    default:
      return state;
  }
};
export default billingReducers;
